/* ============================================================
   CUTE CALCULUS — shared front end
   Reads window.CC_CATALOG and draws the cards every page uses.
   You should never need to edit this file. Add things in
   cc-catalog.js instead.
   ============================================================ */
(function () {
  'use strict';

  var CC = (window.CC = window.CC || {});

  var KINDS = {
    free: { label: 'Free file',   cta: 'Download free' },
    tool: { label: 'Practice',    cta: 'Open it' },
    book: { label: 'Print book',  cta: 'Get it on Amazon' },
    shop: { label: 'Digital',     cta: 'Get it' }
  };

  CC.KINDS = KINDS;

  CC.data = function () {
    var c = window.CC_CATALOG || {};
    return { courses: c.courses || [], items: (c.items || []).filter(function (i) { return i && i.title; }) };
  };

  CC.esc = function (s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  };

  CC.courseName = function (key) {
    var f = CC.data().courses.filter(function (c) { return c.key === key; })[0];
    return f ? f.name : key;
  };

  /* days between the item date and today, NaN if the date is missing or junk */
  CC.age = function (item) {
    if (!item.added) return NaN;
    var t = Date.parse(item.added + 'T12:00:00');
    if (isNaN(t)) return NaN;
    return Math.floor((Date.now() - t) / 86400000);
  };

  CC.isNew = function (item) {
    var a = CC.age(item);
    return !isNaN(a) && a >= -1 && a <= 30;
  };

  /* newest first, undated items fall to the bottom in their listed order */
  CC.byDate = function (items) {
    return items.slice().sort(function (a, b) {
      var x = Date.parse((a.added || '') + 'T12:00:00');
      var y = Date.parse((b.added || '') + 'T12:00:00');
      if (isNaN(x) && isNaN(y)) return 0;
      if (isNaN(x)) return 1;
      if (isNaN(y)) return -1;
      return y - x;
    });
  };

  CC.ago = function (item) {
    var a = CC.age(item);
    if (isNaN(a)) return '';
    if (a <= 0) return 'today';
    if (a === 1) return 'yesterday';
    if (a < 7) return a + ' days ago';
    if (a < 14) return 'last week';
    if (a < 60) return Math.round(a / 7) + ' weeks ago';
    return Math.round(a / 30) + ' months ago';
  };

  CC.isExternal = function (url) { return /^https?:\/\//i.test(url || ''); };

  /* ---------- the one card every page uses ---------- */
  /* opts: {showAge:bool, showCourse:bool, compact:bool} */
  CC.card = function (item, opts) {
    opts = opts || {};
    var e = CC.esc;
    var kind = KINDS[item.kind] || KINDS.free;
    var live = !!(item.url && item.url !== '#');
    var color = item.color || 'blush';
    var cls = 'cc-item cc-c-' + e(color) + (opts.compact ? ' cc-item-compact' : '') + (live ? '' : ' cc-soon');

    var foot = '';
    foot += '<span class="cc-chip cc-chip-ghost">' + e(kind.label) + '</span>';
    if (opts.showCourse && item.course && item.course.length) {
      foot += '<span class="cc-tiny">' + e(CC.courseName(item.course[0])) + '</span>';
    }
    if (item.grade) foot += '<span class="cc-tiny">' + e(item.grade) + '</span>';
    if (item.price) foot += '<span class="cc-chip cc-chip-ghost">' + e(item.price) + '</span>';
    if (item.pages) foot += '<span class="cc-tiny">' + e(item.pages) + ' pages</span>';
    if (opts.showAge && CC.ago(item)) foot += '<span class="cc-tiny">added ' + e(CC.ago(item)) + '</span>';
    if (!live) foot += '<span class="cc-chip cc-chip-ghost">coming soon</span>';

    var inner =
      '<span class="cc-sym" aria-hidden="true">' + e(item.sym || '+') + '</span>' +
      '<span class="cc-grow">' +
        '<span class="cc-item-title">' + e(item.title) +
          (CC.isNew(item) ? ' <span class="cc-chip cc-chip-new">new</span>' : '') +
        '</span>' +
        (item.blurb ? '<span class="cc-item-blurb">' + e(item.blurb) + '</span>' : '') +
        '<span class="cc-item-foot">' + foot + '</span>' +
      '</span>' +
      (live ? '<span class="cc-item-go" aria-hidden="true">→</span>' : '');

    if (!live) return '<div class="' + cls + '">' + inner + '</div>';

    var ext = CC.isExternal(item.url);
    return '<a class="' + cls + '" href="' + e(item.url) + '"' +
      (ext ? ' target="_blank" rel="noopener"' : '') +
      ' data-cc-id="' + e(item.id || '') + '">' + inner + '</a>';
  };

  CC.cards = function (items, opts) {
    if (!items.length) return '';
    return items.map(function (i) { return CC.card(i, opts); }).join('');
  };

  CC.empty = function (title, line) {
    return '<div class="cc-empty"><b>' + CC.esc(title) + '</b>' + CC.esc(line || '') + '</div>';
  };

  /* ---------- boot helper: runs now, on DOM ready, and on Shopify section load ---------- */
  CC.boot = function (fn) {
    var run = function () { try { fn(); } catch (err) { if (window.console) console.error('[cute calculus]', err); } };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  };

  /* ---------- tiny local store, used for progress and the finder ---------- */
  CC.store = {
    get: function (k, d) {
      try { var v = localStorage.getItem('cc:' + k); return v == null ? d : JSON.parse(v); }
      catch (e) { return d; }
    },
        set: function (k, v) {
      try { localStorage.setItem('cc:' + k, JSON.stringify(v)); } catch (e) {}
    }
  };
})();